import { ReactNode } from 'react'
import s from './styles.module.scss'

export const Filters = ({ children, actions }: { children?: React.ReactNode; actions?: ReactNode }) => {
  return (
    <div className={s.container}>
      <div className={s.header}>Filters</div>
      <div className={s.filters}>{children}</div>
      <div className={s.footer}>{actions}</div>
    </div>
  )
}
